module.exports = __webpack_public_path__ + "img/coupon_center_bg.2524ad39.png";